import { DndType } from '~/_shared/constants/dndType.enum';
import { type Theme } from '~/_shared/themes/theme.model';
import { type ColumnRole } from '~/_shared/types/columnRole.enum';
import { mergeDeep } from '~/_shared/utils/object/deepMerge';
import { getLabelRelevantStyles } from '~/customizeLocationPanel/locationData/locationData.helpers';
import { type BubbleEditorItem } from '~/customizeLocationPanel/locationData/locationData.types';
import { getItemDnDType } from './locationData/locationDataItem/draggableItem.helpers';
import {
  type ColumnStyleSettingsData, type PanelBulkStyles,
} from './locationData/panelSettings.types';

export const isItemContactItem = (itemType?: ColumnRole | null) =>
  itemType && getItemDnDType(itemType) === DndType.LocalizationContactItem;

export const defaultLocationDataStyle = (theme: Theme): ColumnStyleSettingsData => ({
  labelFontSize: '15',
  labelFontColor: theme.textColors.info,
  valueFontColor: theme.textColors.primary,
  valueFontSize: '13',
  showLabel: true,
  verticalGap: '0',
});

export const getItemStyles = (
  item: BubbleEditorItem,
  { contactLabelStyle, ...genericBulk }: PanelBulkStyles): ColumnStyleSettingsData => {
  const overrideStyle = item.itemData.style;
  const itemStyles = overrideStyle ? mergeDeep<ColumnStyleSettingsData>({}, genericBulk, overrideStyle) : genericBulk;

  if (isItemContactItem(item.itemType)) {
    const guaranteedContactLabelStyle = contactLabelStyle ?? getLabelRelevantStyles(genericBulk);
    return { ...itemStyles, ...guaranteedContactLabelStyle };
  }

  return itemStyles;
};

export const LOCATION_PANEL_DATA_CLASSNAME = 'LOCATION_PANEL_DATA';

export const EMPTY_LOCATION_DESCRIPTION = {
  header: '',
  description: [''],
  semiHeader: '',
};
